
<template>
  <div class="jumbotron">

    <label style="color:darkblue;font-weight: bolder;">ATTRIBUTI DEL PRODOTTO</label>

    <!-- Riga principale per le select -->
    <div class="row">
      <div
        v-for="attrObj in productAttributes"
        :key="attrObj.attribute.id"
        class="col-auto mb-1"
      >
        <label :for="'attr-' + attrObj.attribute.id">{{ attrObj.attribute.name }}</label>
        <select 
          @change="setData()"
          class="form-control  form-control-sm"
          :id="'attr-' + attrObj.attribute.id"
          v-model="attrObj.selectedValueId"
        >
        <option value='0'>SELEZIONA UN VALORE ...</option>
        <option
            v-for="val in attrObj.attribute.values"
            :key="val.id"
            :value="val.id"
          >
            {{ val.value }}
        </option>
        </select>
      </div>
    </div>

    <!-- Bottone di salvataggio -->
   

    <!-- Preview per debug -->
    <pre v-if="false" class="mt-3">{{ productAttributes }}</pre>
  </div>
</template>

<script>
import api from "@/api"
import { mapGetters }        from 'vuex';
export default {
  props : ['productId'] , 
  data() {
    return {
      // Attributi associati al prodotto con valore selezionato
      productAttributes: []
   
    }
  },
    computed: 
    {     
     ...mapGetters(['company']) 
      
    },
  created()
  {
    this.getData()
  },  
  methods:{

    setData()
    {
       this.$emit('update',this.productAttributes) 
    },
     async getData()
    {
        //this.bt_spinner = true
        
        this.productAttributes = []
        const payload = 
        {
            'productId'   : this.productId,'companyId':this.company.Id   
        
        }
        

        const sp        = {'sp' : 'spProductAttributes'}
        const json      = Object.assign(payload, sp);

        await api.post(json).then(res => {
             
                
          if(res.status==200)
            {
               if(res.data.recordsets[0][0]) 
               {
                  this.productAttributes = res.data.recordsets[0][0]
               }
                               
            }
            else if(res.status==500)
            {
              
              /*  
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    
              */  
            } 
            else
            {
              /*
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
              */
               
            } 
        }).catch(err => 
        {
          /*
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            */
            
        }).finally(() => {
          //this.bt_spinner = false
        });

      
    },  


  }
}
</script>
<style scoped>

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
</style>